import { Category, ReactionType } from '../../../services/widget-settings-service';

export const isWithVotes = (reactionType?: Category['reactionType']) =>
  reactionType === ReactionType.VOTE;
